import * as Sentry from "@sentry/react";

import {
  darkActions,
  darkBackground,
  darkError,
  darkSuccess,
  darkText,
  lightActions,
  lightBackground,
  lightError,
  lightPrimary,
  lightSuccess,
  lightText,
} from "./colors";

Sentry.init({
  dsn: "https://8066db21e9ba550dca64730fd401bf86@sentry.signalos.tech/15",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        /^https:\/\/api.parkiza.dev.signalos\.app/,
        /^https:\/\/api.parkiza.prod.signalos\.app/,
        // OLD URLS
        "https://parking-api.signalos.app",
        "https://test-parking-api.signalos.app",
      ],
    }),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      autoInject: false,
      showBranding: false,
      themeLight: {
        foreground: lightText.primary,
        background: lightBackground.paper,
        accentForeground: lightPrimary.dark,
        accentBackground: "#E9F5F8",
        successColor: lightSuccess.main,
        errorColor: lightError.main,
        boxShadow: "0px 4px 24px 0px rgba(9, 30, 66, 0.12)",
        outline: `1px auto ${lightActions.focus}`,
      },
      themeDark: {
        foreground: darkText.primary,
        background: darkBackground.paper,
        accentForeground: lightPrimary.light,
        accentBackground: "#305868",
        successColor: darkSuccess.main,
        errorColor: darkError.main,
        boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.32)",
        outline: `1px auto ${darkActions.focus}`,
      },
    }),
  ],

  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api.parkiza.dev.signalos\.app/,
    /^https:\/\/api.parkiza.prod.signalos\.app/,
    // OLD URLS
    "https://parking-api.signalos.app",
    "https://test-parking-api.signalos.app",
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: import.meta.env.PROD ? "production" : "development",
  enabled: import.meta.env.PROD,
  // beforeSend(event, hint) {
  //   // Check if it is an exception, and if so, show the report dialog
  //   if (event.exception && event.event_id) {
  //     Sentry.showReportDialog({ eventId: event.event_id });
  //   }

  //   return event;
  // },
});
